import React from 'react';
import {
    PanelHeader,
    Div,

    SplitCol,
    SplitLayout,
    Button,
    ButtonGroup,

    ModalRoot,
    ModalPage,
    ModalPageHeader,
    PanelHeaderButton,
    FormItem,
    Textarea,
    Accordion, Chip
} from '@vkontakte/vkui';


import {
    AdaptivityContext,
    CODE_SALE_POINT_MONITORING_STATUS_DRAFT,
    CODE_SALE_POINT_MONITORING_STATUS_NEW,
    getMonitoringQuestions,
    getStaffPositions,
    setQuizStep
} from "../assets/constants";

import BaseComponent from "../components/BaseComponent";
import withOffline from "../components/withOffline";
import SalePointMonitoringDocsApi from "../api/SalePointMonitoringDocs";


import * as constants from "../assets/constants";
import {Icon24Cancel, Icon24Done} from "@vkontakte/icons";
import SummaryListSalePoint from "./SummaryList";
import SalePointMonitoringDocsSync from "../utils/localDB/salePointMonitoringDocs";
import HelpButton from "../assets/HelpButton";


class SalePointMonitoringStep5 extends BaseComponent {


    statusLabels = constants.getSalePointMonitoringStatuses()
    spTypes = constants.getSalePointsTypes()


    constructor(props) {
        super(props)
        const {item} = props

        this.state = {
            docComment: item && item.doc_data && item.doc_data.comment ? item.doc_data.comment : '',
            ...this.state
        }

    }

    receiveMessage = (event) => {


    }

    formatAnswerDisplay = (question, answer) => {
        if (!answer) return '—';
        if (question.type === 'yesno') {
            if (String(answer.value) === '1') return 'Да';
            if (String(answer.value) === '0') return 'Нет';
            return '—';
        }
        if (question.type === 'number') {
            return answer.value_num != null && answer.value_num !== '' ? String(answer.value_num) : '—';
        }
        if (question.type === 'select') {
            return answer.value || '—';
        }
        if (question.type === 'multiselect') {
            const ids = (answer.option_ids || []).map(String);
            const titles = (question.options || []).filter(o => ids.includes(String(o.id))).map(o => o.title);
            return titles.length ? titles.join(', ') : '—';
        }
        if (question.type === 'tree') {
            const labels = (answer.values || []).map(v => v.label || v.title).filter(Boolean);
            return labels.length ? labels.join(', ') : '—';
        }
        if (question.type === 'date' && answer.value) {
            const ts = Number(answer.value);
            if (!isNaN(ts) && ts > 0) {
                return new Date(ts * 1000).toLocaleDateString('ru-RU');
            }
        }
        return answer.value || '—';
    };

    renderQuestionnaireSummary = () => {
        const {item} = this.props;
        const questionnaire = item && item.questionnaire ? item.questionnaire : {answers: [], sellers: []};
        const schema = getMonitoringQuestions();
        const questions = schema.questions || [];
        const qualifications = schema.qualifications || {};
        const positions = getStaffPositions();

        if (!questions.length && !(questionnaire.sellers || []).length) {
            return null;
        }

        const answersByQ = {};
        (questionnaire.answers || []).forEach(a => {
            if (a && a.question_id) answersByQ[a.question_id] = a;
        });

        const activeSellers = (questionnaire.sellers || []).filter(s => !s.removed);

        return (
            <>
                <SplitLayout>
                    <SplitCol>
                        <Accordion className="summary-element" defaultExpanded={true}>
                            <Accordion.Summary>Опросник</Accordion.Summary>
                            <Div>
                                {questions.filter(q => q.type !== 'sellers').map(q => (
                                    <Div key={q.id} style={{marginBottom: 8}}>
                                        <b>{q.title}</b>
                                        <div>{this.formatAnswerDisplay(q, answersByQ[q.id])}</div>
                                    </Div>
                                ))}
                                {activeSellers.length > 0 && (
                                    <Div>
                                        <b>Сотрудники ({activeSellers.length})</b>
                                        {activeSellers.map((s, i) => (
                                            <Div key={s.guid || i} style={{marginTop: 6, paddingLeft: 8}}>
                                                {i + 1}. {[s.last_name, s.first_name, s.middle_name].filter(Boolean).join(' ')}
                                                {s.phone ? `, ${s.phone}` : ''}
                                                {(s.position_title || positions[s.position_id]) ? ` — ${s.position_title || positions[s.position_id]}` : ''}
                                                {s.qualification ? ` — ${qualifications[s.qualification] || ''}` : ''}
                                                {s.is_owner ? ' (собственник)' : ''}
                                                {s.is_lpr ? ' (ЛПР)' : ''}
                                            </Div>
                                        ))}
                                    </Div>
                                )}
                            </Div>
                        </Accordion>
                    </SplitCol>
                </SplitLayout>
            </>
        );
    };


    render() {
        const images_url = this.props.base_url.replace("frontend/", '')


        const foundCnt = {}
        const competitorCnt = {}

        const {item} = this.props

        const items_values = item && item.items ? item.items : []
        const sale_point = item && item.doc_data ? item.doc_data.sale_point : null

        Object.keys(items_values).map((id) => {
            const currentItem = items_values[id]
            // Проверяем что элемент не null
            if (currentItem && currentItem.is_competitor) {
                competitorCnt[id] = currentItem
            } else if (currentItem) {
                foundCnt[id] = currentItem
            }
        })


        const modals = (
            <ModalRoot activeModal={this.state.activeModal}>

                <ModalPage hideCloseButton={true}
                           id={constants.MODAL_SEND_ORDER}
                           onClose={this.modalBack}

                           style={{
                               width: "100%", marginBottom: "100px"
                           }}
                           header={
                               <ModalPageHeader
                                   after={<PanelHeaderButton
                                       onClick={this.modalBack}><Icon24Cancel/></PanelHeaderButton>}

                               >
                                   Завершение мониторинга торговой точки
                               </ModalPageHeader>
                           }
                >
                    <Div>Завершить мониторинг торговой точки?</Div>
                    <FormItem top="Комментарий">
                        <Textarea autoFocus value={this.state.docComment} rows={7}
                                  placeholder="Укажите состояние стенда, что сломано, требует ремонта, переклейки и т.п."
                                  onChange={e => this.setState({docComment: e.currentTarget.value})}/>
                    </FormItem>
                    <Div style={{marginBottom: '100px'}}>
                        <ButtonGroup mode="horizontal" stretched>
                            <Button before={<Icon24Done/>} size="l" stretched disabled={this.state.loading}
                                    loading={this.state.loading}
                                    onClick={() => this.sendDoc()}>Да</Button>
                            <Button before={<Icon24Cancel/>} size="l" stretched disabled={this.state.loading}
                                    onClick={() => this.setActiveModal(null)}>Нет</Button>
                        </ButtonGroup>
                    </Div>
                </ModalPage>
            </ModalRoot>

        );
        return (
            <div>
                <SplitLayout modal={modals}>
                    <SplitCol>

                        <PanelHeader fixed={true}>
                            <Div>
                                Итоги
                                {this.props.isOffline && <Chip removable={false}  className="all-docs"
                                                               id="is_offline">Offline  режим<HelpButton
                                    text={"Нет связи с интернет. Работаем в автономном режиме"}/></Chip>
                                }
                            </Div>
                        </PanelHeader>

                    </SplitCol>
                </SplitLayout>
                <SplitLayout>
                    <SplitCol>
                        <Div className="summary-element">
                            Мониторинг торговой точки завершен. Ниже итоги. Можно фильтрами проверить позиции. Нажмите
                            завершить
                        </Div>
                    </SplitCol>
                </SplitLayout>

                <SplitLayout>
                    <SplitCol>
                        <Div className="summary-element">
                            Клиент: {item && item.doc_data && item.doc_data.klient ? item.doc_data.klient.title : "Не указан"}
                        </Div>
                    </SplitCol>
                </SplitLayout>
                <SplitLayout>
                    <SplitCol>
                        <Div className="summary-element">
                            Торговая
                            точка: {sale_point && sale_point.uid?`${this.spTypes[sale_point.type_]} ${sale_point.title}  ${sale_point.full_address} `:'Не указана'}
                        </Div>
                    </SplitCol>
                </SplitLayout>


                <SplitLayout>
                    <SplitCol>
                        <Accordion className="summary-element">
                            <Accordion.Summary>Наши стенды: {Object.keys(foundCnt).length}</Accordion.Summary>
                            <SummaryListSalePoint list={foundCnt} current_document={item}/>
                        </Accordion>
                    </SplitCol>
                </SplitLayout>

                <SplitLayout>
                    <SplitCol>
                        <Accordion className="summary-element">
                            <Accordion.Summary>Стенды
                                конкурентов: {Object.keys(competitorCnt).length}</Accordion.Summary>
                            <SummaryListSalePoint list={competitorCnt} current_document={item}/>
                        </Accordion>
                    </SplitCol>
                </SplitLayout>

                {this.renderQuestionnaireSummary()}

                <SplitLayout style={{marginBottom: '150px'}}>
                    <SplitCol>
                    </SplitCol>
                </SplitLayout>

                <SplitLayout>
                    <SplitCol>
                        <Div className="action-board">
                            <ButtonGroup mode="horizontal" stretched>
                                <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                        onClick={() => setQuizStep(5, 'SalePointMonitoring')}>Назад</Button>
                                <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                        onClick={() => this.setActiveModal(constants.MODAL_SEND_ORDER)}
                                >Завершить</Button>
                            </ButtonGroup>
                        </Div>
                    </SplitCol>
                </SplitLayout>
            </div>
        )
    }

    sendDoc = () => {

        const {item} = this.props
        item.docComment = this.state.docComment
        this.setState({loading: true})
        try{
        new SalePointMonitoringDocsSync().add(item).then(() => {
            this.setActiveModal(null)
            window.postMessage({type: 'endSalePointMonitoring'})
        })
        }catch (e){
            window.postMessage({type:'error', text: e.message})
            setTimeout(() => {
                this.setActiveModal(null)
                window.postMessage({type: 'endSalePointMonitoring'})
            })
        }

    }


}

export default withOffline(SalePointMonitoringStep5)
